import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { USER_TYPE } from '../../../../../../../constants'
import Icon from '../../../../../../atoms/Icon'

export const AllAccountAccessCell = ({ id, row, disabled, onChange, classes }) => {
  useEffect(() => {
    if (row.userTypeId !== USER_TYPE.ADVISOR && row.allAccountAccess) {
      onChange({ target: { value: false } })
    }
  }, [row.userTypeId, onChange, row.allAccountAccess])

  if (row.userTypeId !== USER_TYPE.ADVISOR) {
    return (
      <p className={classes.disabledDisplay}>
        --
      </p>
    )
  }

  if (disabled) {
    return (
      <p className={classes.disabledDisplay}>
        {row.allAccountAccess ? <Icon name='check' color='green' /> : <Icon name='close' color='red' />}
      </p>
    )
  }

  return (
    <>
      <input
        type='checkbox'
        value='true'
        id={id}
        checked={row.allAccountAccess}
        onChange={(e) => {
          onChange({ target: { value: e.target.checked } })
        }}
      />
    </>
  )
}

AllAccountAccessCell.propTypes = {
  id: PropTypes.string,
  row: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  classes: PropTypes.object
}
